import { faXmark } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const ModalHeader =({modalTitle, onClose})=>{
    return <div className="relative border-b-2 pb-4">
     {modalTitle && <h3 className="text-[24px] font-semi-bold leading-[1]">{modalTitle}</h3>}
          <button onClick={onClose} className="absolute top-[-9px] right-[0px] bg-[transparent] cursor-pointer text-[28px]">
            <FontAwesomeIcon icon={faXmark}/>
          </button>
    </div>
}
export default ModalHeader